import sortArrayByCondition from '../common/sort-array-by-condition'

const getSortedPhoneNumbers = function (state) {
  return function (collection: any[]) {
    const result = sortArrayByCondition(
      collection,
      item => state.locationTwilio?.defaultOutboundNumber === item?.phone_number,
      "sid"
    )

    return result
  }
}

export default getSortedPhoneNumbers
